import axios from "axios";
import { getHttpConfigWithToken } from "../../../util/httpConfigWithToken";
import { Api, decryptApiResponse } from "../../../config/Api";
import { decryptData } from "../../../config/encryptData";

export const getJsonViewerDataFromApi = async (data) => {
  const response = await Api.post(
    process.env.REACT_APP_BASE_URL + "/api/v2/iv/realtime",
    data,
  );

  return "value" in response.data
    ? decryptApiResponse(response)
    : response.data;
};

export const getPayerList = async () => {
  const response = await Api.get(
    process.env.REACT_APP_BASE_URL + "/api/v2/iv/realtime/payers",
  );

  return decryptApiResponse(response);
};
